import Api from "@/axios/api";

// Failed physical gift sends and failed eGift sends (failed payment) are listed separately.
export const FAILED_SEND_KINDS = Object.freeze({
  PHYSICAL: 'physical',
  EGIFT: 'egift',
});

export class FailedSendsService {
  static async getFailedActions(type = FAILED_SEND_KINDS.PHYSICAL) {
    const { data } = await Api.get('/customer/customer-automations/failed-actions', {
      params: { type },
    });
    return data;
  }

  static async postCalculatePrices(payload, signal) {
   return await Api.post(
      '/customer/customer-automations/failed-actions/calculate',
      payload,
      { signal }
    );
  }

  static async postFailedActions(payload) {
    return await Api.post('/customer/customer-automations/failed-actions/run', payload);
  }

  static async postDismissActions(payload) {
    return await Api.post('/customer/customer-automations/failed-actions/dismiss', payload);
  }
}
